import * as React from 'react';
import { QuestionTagLinkCreateInput, QuestionTagLinkUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useCreateQuestionTagLinkCallback } from './useCreateQuestionTagLinkCallback';
import { useUpdateQuestionTagLinkCallback } from './useUpdateQuestionTagLinkCallback';
import { QuestionTagLink } from '../models/QuestionTagLink';

/**
 * Get a callback to save a QuestionTagLink in the store using either a create or update.
 */
export function useSaveQuestionTagLinkCallback(options: SaveInStoreOptions<QuestionTagLink, string> = {}) {
    const [_create, createStatus] = useCreateQuestionTagLinkCallback();
    const create = React.useCallback((model: Partial<QuestionTagLink>) => _create(model as QuestionTagLinkCreateInput), [_create]);

    const [_update, updateStatus] = useUpdateQuestionTagLinkCallback();
    const update = React.useCallback((id: string, changes: Partial<QuestionTagLink>) => _update(id, changes as QuestionTagLinkUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
